export default class UnicodeUtil {
    /**
     * @param {Number} unicodeCodePoint - a hex string representing a unicode character
     */
    static getStringFromUnicodeCodePoint(unicodeCodePoint) {
        return String.fromCharCode(parseInt(unicodeCodePoint, 16));
    }

    /**
     * A 0-width character which can be used as a placeholder in an HTML element so that the element doesn't change size when content is added
     */
    static get zeroWidthSpace() {
        // U+200B = "Zero Width Space"
        return UnicodeUtil.getStringFromUnicodeCodePoint('200B');
    }

    static get heavyCheckMark() {
        // U+2714 = "Heavy Check Mark"
        return UnicodeUtil.getStringFromUnicodeCodePoint('2714');
    }

    static get heavyBallotX() {
        // U+2718 = "Heavy Ballot X"
        return UnicodeUtil.getStringFromUnicodeCodePoint('2718');
    }
}



// WEBPACK FOOTER //
// ./src/utils/UnicodeUtil.js